import React from 'react';
import styles from './Library.module.scss';
import {TabSwitcher} from './components';
import {Route, Switch, useHistory, useRouteMatch} from 'react-router';
import {
  RecentlyAddedPage,
  SongsPage,
  AlbumViewPage,
  Albums,
  PlaylistViewPage,
  Playlists,
} from './Pages';

export enum Tab {
  Recent = '/library/recent',
  Song = '/library/songs',
  Artist = '/library/artists',
  Album = '/library/albums',
  Playlist = '/library/playlists',
}

export default function Library() {
  const match = useRouteMatch();
  const history = useHistory();

  const activePageMarkup = (
    <Switch>
      <Route
        path={`${match.url}/recent`}
        component={withTabSwitcher(RecentlyAddedPage)}
      />
      <Route
        path={`${match.url}/songs`}
        component={withTabSwitcher(SongsPage)}
      />
      <Route
        path={`${match.url}/artists`}
        component={withTabSwitcher(() => null)}
      />
      <Route path={`${match.url}/albums`} component={withTabSwitcher(Albums)} />
      <Route
        path={`${match.url}/playlists`}
        component={withTabSwitcher(Playlists)}
      />
      <Route path={`${match.url}/album/:id`} component={AlbumViewPage} />
      <Route path={`${match.url}/playlist/:id`} component={PlaylistViewPage} />
      <Route
        path={match.url}
        component={() => {
          history.push(`${match.url}/recent`); // Redirect /library to /library/recent
          return null;
        }}
      />
    </Switch>
  );

  return (
    <div className={styles.Library}>
      <div className={styles.LibraryPage}>{activePageMarkup}</div>
    </div>
  );
}

function withTabSwitcher<T>(Component: React.ComponentType<T>) {
  return (props: T) => (
    <>
      <TabSwitcher />
      <Component {...props} />
    </>
  );
}
